










export interface S3File {
  itemType: 'file';
  id: string; // Typically prefix + name
  name: string; // e.g., "image1.jpg"
  displayName?: string; // User-friendly short name, e.g., "Category - Serial"
  url: string; // URL to the image
  prefix: string; // Path to the directory containing the file, e.g., "Fase01/___P3/2025-05-14/"
  descriptionTextPath: string; // Full path to the .txt file, e.g., "Fase01/___P3/2025-05-14/image1.txt"
  descriptionText?: string; // Loaded description from a .txt file
  parsedDate?: string;
  parsedTime?: string;
  parsedMachineCode?: string; // Added for machine code
  star?: StarType; 
}

export interface S3Folder {
  itemType: 'folder';
  id: string; // Typically prefix + name
  name: string; // User-friendly name (e.g., "Encorsetadas") or directory name (e.g., "Fase01", "___P3")
  path: string; // The actual S3 prefix this folder represents, e.g., "Fase01/" or "Fase01/___P3/"
}

export type S3ListItem = S3Folder | S3File;

export enum StarType {
  None = 'NONE',
  YellowStar = 'YELLOW_STAR',
  RedExclamation = 'RED_EXCLAMATION',
  BlueFlag = 'BLUE_FLAG',
  GreenTick = 'GREEN_TICK',
  PurplePin = 'PURPLE_PIN',
  OrangeDiamond = 'ORANGE_DIAMOND',
  // New Types
  PinkStar = 'PINK_STAR',
  LightBlueStar = 'LIGHT_BLUE_STAR',
  TealStar = 'TEAL_STAR',
  LimeStar = 'LIME_STAR',
  AmberStar = 'AMBER_STAR',
  RedStar = 'RED_STAR',
  GreyStar = 'GREY_STAR',
  PurpleQuestion = 'PURPLE_QUESTION',
  CyanInfo = 'CYAN_INFO',
  GreenArrowRight = 'GREEN_ARROW_RIGHT',
  BlueArrowLeft = 'BLUE_ARROW_LEFT',
  OrangeDoubleExclamation = 'ORANGE_DOUBLE_EXCLAMATION',
  IndigoPin = 'INDIGO_PIN',
}

export interface DisplayedImage {
  id: string;
  url:string;
  alt: string; // Full original filename for parsing details
  displayName?: string; // User-friendly short name for display
  description?: string; // Parsed/formatted description for display
  rawDescription?: string; // Raw infotext from .txt file
  isGenerated?: boolean;
  promptUsed?: string;
  analysisResult?: string;
  appliedEdit?: string;
  isSaved?: boolean; // New flag: true if saved to "My AI Creations" (drafts)
  isExported?: boolean; // New flag: true if saved to "My Final Artwork"
  savedToCustomFolderPath?: string; // Path like "Fase99/username/MyVacationPics/" if saved to a custom folder (root of custom folder)
  s3Prefix?: string; // Actual S3 directory path where the image is stored (e.g., Fase99/user/MyCustomFolder/2023-10-26/)
  star?: StarType; // For Gmail-like star marking
  parsedDate?: string;
  parsedTime?: string;
  parsedMachineCode?: string; // Added for machine code
}

export enum EditMode {
  Generate = "GENERATE",
  Analyze = "ANALYZE",
  QuickEdit = "QUICK_EDIT",
  ManageCustomEdits = "MANAGE_CUSTOM_EDITS"
}

export interface QuickEditAction {
  id: string;
  label: string;
  promptGenerator: (baseSubject: string) => string;
  isCustom?: boolean;
}

export type FilterType = 'date' | 'artist' | 'machineCode' | 'star';

export interface ActiveFilter {
  type: FilterType;
  value: string; // The raw value to filter by (e.g., "2025-05-14", "www.arteai.eu", "P3", "YELLOW_STAR")
  displayName: string; // User-friendly display for the filter (e.g., "Fecha: 14/05/2025", "Favoritas: Estrella Amarilla")
}

export interface NavigationState {
  browseToPath: string;
  isUserGalleryActive: boolean;
  activeFilter: ActiveFilter | null;
  selectedS3FileId: string | null; // Store ID of S3File selected in browser
}

export enum UserTier {
  Free = "Free",
  Basic = "Basic",
  Premium = "Premium",
  DeLuxe = "DeLuxe"
}

export interface UserProfile {
  username: string;
  email: string;
  registrationDate: string; // ISO date string, e.g., new Date().toISOString()
  tier: UserTier;
}

export type AppView = 'landing' | 'studio' | 'store' | 'profile';

export type SaveDestinationType = 'drafts' | 'finalArtwork' | 'custom';

export interface CustomFolder {
  id: string; // e.g., `custom-folder-${Date.now()}`
  name: string; // User-defined name, e.g., "Vacaciones 2024"
  color: string; // Tailwind CSS background color class, e.g., "bg-blue-500"
  // Path is implicitly: GENERATED_IMAGES_FASE_PATH + "/" + username + "/" + name + "/"
}